<template>
	
	<div :class="classes">
		
		<!-- home page -->
		<NavMobile 
			v-bind:menus="this.website_menu" 
			v-bind:website_logo="this.website_logo"
			v-bind:website_mobile_logo="this.website_mobile_logo"
			v-bind:website_url="this.website_url" 
			v-bind:website_title="this.website_title"
			/>
		<header id="header" class="header">
			<HeaderTop
				v-bind:website_hide_gco="this.website_hide_gco" 
				v-bind:website_logo="this.website_logo" 
				v-bind:website_mobile_logo="this.website_mobile_logo"
				v-bind:website_url="this.website_url" 
				v-bind:website_title="this.website_title"
				/>
      <Nav 
      	v-bind:menus="this.website_menu"
      	v-bind:website_logo="this.website_logo"
      	v-bind:website_title="this.website_title"
      	/>
      <SocialLeft v-if="show_social==true"/>
		</header>

		<!-- standard page ( about / source&methods / help) -->
		<!--<header id="header" class="header" v-if="current_route != '/'">
			<HeaderTopPage 
				v-bind:website_hide_gco="this.website_hide_gco" 
				v-bind:website_logo="this.website_logo" 
				v-bind:website_url="this.website_url" 
				v-bind:website_title="this.website_title" 
				v-bind:menus="this.website_menu" 
				v-bind:submenu="this.submenu"
				/>
			<SocialLeft v-if="show_social==true"/>
		</header>-->

		<!-- main page -->
		<!--<transition name="fade" mode="out-in">
			<router-view :key="$route.path"/>
		</transition>-->

		<router-view :key="$route.path" />

		<!-- common footer -->
		<Footer/>

	</div>

</template>

<script>

import HeaderTop from './HeaderTop.vue'
//import HeaderTopPage from './HeaderTopPage.vue'
import Nav from './Nav.vue'
import NavMobile from './NavMobile.vue'
import Footer from './Footer.vue'
import SocialLeft from './SocialLeft.vue'

export default {
  name: 'IARCLayout',
  components: {
  	HeaderTop , Nav , NavMobile , SocialLeft , Footer
  },
  props : {
  	website_hide_gco : { type : Boolean , default : false },
    website_logo : { type : String } , 
    website_mobile_logo : { type : String } , 
    website_url : { type : String } , 
    website_title : { type : String },
    website_menu : { type : Array , 
  		default : []
  	}
  },
  data () {
    return {
    	current_route : '' ,
    	classes : ['iarc_layout','page-template','show-bottom-menu','iarc-site-www'] ,
	    submenu : [] , 
	    show_social : false 
    }
  },
  mounted () { 
  	// this.route = this.$router.currentRoute.path
  	// console.log("document.location.pathname",document.location.pathname,document.location.pathname.search("dataviz") != -1 ) ;
  	
  	this.website_menu.map( m =>{
  		let classes = ["menu-item"] ;
  		if ( document.location.pathname == m.path ) {
  			classes.push("current-menu-item") ; 
  			if ( document.location.pathname == "/today/data-sources-methods-2")
  				this.submenu = m.submenu ; 
  		}
  		m.class = classes.join(' '); 
  		return m ; 
  	})

  	this.current_route = document.location.pathname ; 

  	//console.info("this.current_route",this.current_route) ; 
  	//if ( this.current_route == '/') {
		this.classes.push('custom-home-page')
  	this.classes.push('homepage-iarc')
  	//}
  	
  	if ( document.location.pathname.search("dataviz") != -1 ) this.show_social = false ; 
  	// console.log("this.show_social",this.show_social) ;
  },
  watch: { 
  	$route (to, from){
    	$('body').removeClass('burger-body');
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss">

// Import from master-IARC new template : see (style.css to see import or import directly style.css)
$font_family : "Object Sans", sans-serif ;


@import './assets/_variables.scss' ;

$blue : $color_dark_blue ; 
$peach : $color_peach ; 

@import './assets/bootstrap.v5.2.min.css' ;
@import './assets/base-new.css' ;
@import './assets/header-vertical.css' ;
@import './assets/header-home-page.css' ;
@import './assets/responsive.css' ;
@import './assets/print.css' ;
@import './assets/new-design.css' ;

@import './assets/css/icomoon.css' ;
@import './assets/graphic.scss' ; 
@import './assets/sub-menu.scss' ; 

/* Custom additional css */

body.long-read {

	header#header{
		position: fixed;
    width: 100%;
	}
	main{

	}
}

body.vertical-scroll-theme {
	main{
		top: 0px!important;
	}
}


.main-menu {
	.header-menu-links{
		.menu-item:first-child{
			margin-left: 0px !important;
			a{
				margin-left: 0px;
			}
		}
		.menu-item{
			margin-right: 30px;
		}
	}
}

.iarc_layout{

	#header-menu{
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
	}

	img.gco_logo{
		max-height: 70px; 
		margin-right: 20px;
	}

	img.website-logo{
		max-height: 70px; 
	}

	a{
  	i{
  		color: $peach ;
  	}
	}

	h1 {
	    font-weight: 700;
	    font-size: 60px;
	    line-height: 100%;
	    margin-top: 30px;
	}

	&.long-read {
		.header-bar {
		    position: fixed;
		    top: 0;
		    background-color: white;
		    opacity: 0.9;
		    width: 100%;
		    z-index: 10;
		}

		main{
			position: relative;
    		top: 175px;
		}
	}

	.breadcrumb{
		display: none ;
	}

	.menu-item:not(.menu-item-mobile) a.router-link-active.router-link-exact-active,
	.menu-item:not(.menu-item-mobile) a.router-link-active{
		font-weight: 700!important;
		border-bottom: solid 2px #fff;
		color: #fff!important;
		opacity: 1!important;
	}

	main.no_tabs_menu{
		padding-top: 0px !important;
	}

	main#main{
		.entry-content{
			padding-bottom: 50px;
		}
	}

	.scrollable-tabs-nav{
		flex-wrap: nowrap;
	  overflow: hidden;
	  /* Might not be needed based on your styling */
	  margin-bottom: -14px;
	}

	.nav-tabs .nav-link{
		font-size: 14px;
	}

	article{
		min-height: 600px ; 
		position: relative ;
		.anchor{
			top: -200px;
		}
	}

	table.table{
		font-size: .9em;
	}

	.anchor{

	}

	.bloc_sub_container{
		.tab_downloads_sub_block h3{
			color: $peach ;
		}
	}

	form {
	  fieldset {
	    h4{
	      a.container_fieldset_icon{
	      	i{
	      		color: $peach ;
	      	}
	      }
	      a{
	      	color: $peach ;
	      }
	    }
	    &.container_switcher_circle_pop{
	    	i{
      		color: $peach ;
      	}
	    }
	  }
	  label.sort_icon {
	  	input:checked + i{
	  		border: solid 2px $peach;
	  	}
	  	&:hover{
	  		i{
	  			background-color: $peach ; 
	  		}
	  	}
	  }
	}

	/* graphic */
	.page.dataviz.scrolling{
		
		#container-sub-menu,.tabs.dataviz-tabs{
			margin-top: 55px !important; 
		}

		#container-filters{
			top: 55px!important;
		}
	}

	.table-responsive{
		table{
			font-family: Arial!important;
			th,td{
				font-family: Arial!important;
			}
		}	
	}

	/* table (dataviz) */
	table.table-dataset{
		
		thead{
			th{
				text-align: right ; 
				a{
					color: #000 ; 
				}
			}
		}
		tbody{
			td{
				text-align: right ; 
			}
		}
	}

	.icon-desc{
		font-family: $font_family !important ; 
	}

	.container-anchor{
    position: relative ;
    .anchor{
      position: absolute;
      top: -180px ;
    }
  }

}




</style>